export function paybillsMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      paybillsId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdatePaybillsId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManyPaybillss(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreatePaybillsId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function paybillsMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, paybillsId: json.result.objectId},
  };
}